import { SegmentedControlProps } from 'blaze-ui/SegmentedControl/Types'
import { SegmentedControl } from 'blaze-ui/SegmentedControl/SegmentedControl'
import { ThumbDown, ThumbUp } from 'blaze-ui/icons'
import { Item } from '@react-stately/collections'

export const RatingSegmentedControl = ({
  rounded = true,
  variant = 'secondary',
  isFullWidth = true,
  ...rest
}: Omit<SegmentedControlProps, 'items' | 'children'>) => {
  return (
    <SegmentedControl isFullWidth={isFullWidth} rounded={rounded} variant={variant} {...rest}>
      <Item key="downvote" textValue="Thumb Down">
        <ThumbDown />
      </Item>
      <Item key="upvote" textValue="Thumb Up">
        <ThumbUp />
      </Item>
    </SegmentedControl>
  )
}
